import { type ClassValue, clsx } from "clsx";
import slugify from "slugify";
import { twMerge } from "tailwind-merge";

// =============================================================================

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// =============================================================================

/**
 * Create a URL friendly slug from a string
 * @example createSlug("Sunlight Services"); // "sunlight-services"
 */
export function createSlug(text: string): string {
  return slugify(text, { lower: true, strict: true, locale: "fr", trim: true });
}

// =============================================================================

/**
 * Pad a number with leading zeros ("01", "02"…)
 */
export function padNumber(value: number, length = 2): string {
  return String(value).padStart(length, "0");
}

/**
 * Clamp a number between a minimum and a maximum
 */
export function clamp(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), max);
}

// =============================================================================
